// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1NQ9o","title":"AfterBackImages_title__1xtQX","images":"AfterBackImages_images__3dUIJ"};